import React from "react";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

export const ModalEliminar = (props) => {

    const { mostrar, cerrarModal, nombreArchivoTxt, funcionEliminar } = props;

    const footer = (
        <div>
            <Button label="Si" icon="pi pi-check" onClick={() => funcionEliminar()} />
            <Button label="No" icon="pi pi-times" onClick={() => cerrarModal()} />
        </div>
    );

    return (
        <div>
            <Dialog header="Eliminar Lote" visible={mostrar} style={{ width: '50vw' }} modal={true}
                onHide={cerrarModal} footer={footer}>
                ¿Está usted seguro de eliminar el archivo <strong>{nombreArchivoTxt}</strong> y todo lo relacionado con el mismo?,
                este proceso ya no puede revertirse, si está seguro dar click en <strong>Si</strong> de lo contrario elegir <strong>No</strong>
            </Dialog>
        </div>
    );
}